import * as map from './data/map.json';
import {innerHTML, toggleClass, capitalize} from './utils';
import {useMobileVersion} from './config';
import header from './templates/header';
import footer from './templates/footer';
import * as headerMobileUtils from './templates/header/mobileUtils';
import * as headerDesktopUtils from './templates/header/desktopUtils';
import cssHeaderMobile from './templates/header/mobile.scss';
import cssFooterMobile from './templates/footer/mobile.scss';
import cssHeaderDesktop from './templates/header/desktop.scss';
import cssFooterDesktop from './templates/footer/desktop.scss';

const css = {cssHeaderMobile, cssFooterMobile, cssHeaderDesktop, cssFooterDesktop};

export default function (nodes, config, translations, user) {
  const isMobile = useMobileVersion(config);
  const context = {map, translations, isMobile, config, user};

  ['header', 'footer'].forEach(part => {
    const cssModule = css[`css${capitalize(part)}${capitalize(isMobile ? 'mobile' : 'desktop')}`];
    if (config.hostPage && cssModule[config.hostPage]) {
      toggleClass(document.body, cssModule[config.hostPage], true);
    }
    innerHTML(nodes[part],
      {header, footer}[part](context),
      cssModule.container,
      config.language);
  });

  if (isMobile) {
    headerMobileUtils.markCurrentMenuItem();
    headerMobileUtils.bindStateChangeListener();
    headerMobileUtils.bindLinkClicks();
    headerMobileUtils.preventSafariBackButtonCache();
  } else {
    headerDesktopUtils.markCurrentMenuItem();
  }
}



// WEBPACK FOOTER //
// ./render.js